var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 42,
    viewBox: "0 0 141 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_209_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.56 25.22L164.62 34.4C159.68 39.47 151.57 39.57 146.5 34.64C141.43 29.7 133.32 29.81 128.38 34.88C123.44 39.95 115.33 40.05 110.26 35.12C105.19 30.18 97.08 30.29 92.14 35.36C87.2 40.43 79.09 40.53 74.02 35.6C68.95 30.66 60.84 30.77 55.9 35.84C50.96 40.91 42.85 41.01 37.78 36.08L28.6 27.14L27.88 27.15",
    stroke: "#15A280",
    strokeWidth: 3.0007,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18 1.5L138.24 10.68C133.3 15.75 125.19 15.85 120.12 10.92C115.05 5.98 106.94 6.09 102 11.16C97.06 16.23 88.95 16.33 83.88 11.4C78.81 6.46 70.7 6.57 65.76 11.64C60.82 16.71 52.71 16.81 47.64 11.88C42.57 6.94 34.46 7.05 29.52 12.12C24.58 17.19 16.47 17.29 11.4 12.36L2.22 3.41L1.5 3.42",
    stroke: "#15A280",
    strokeWidth: 3.0007,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.06,
    height: 41.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.e52f89f95284d8730d32686c28935715.svg";
export { ForwardRef as ReactComponent };